//tslint:disable

import React, { useEffect, useState } from "react";
import { Editor } from '@tinymce/tinymce-react';
import axios from "axios";

const DragAndDropWordMatching = ({ course, topic, lesson, dragDropInfo, edit }) => {
  const [isError, setError] = useState(false);
  const [isErrorPair, setErrorPair] = useState(false);
  const [isErrorPairEmpty, setErrorPairEmpty] = useState(false);
  const [isErrorPriority, setErrorPriority] = useState(false);
  const [kind, setKind] = useState('word_matching');
  const [question, setQuestion] = useState(dragDropInfo ? dragDropInfo.question : '');
  const [explanation, setExplanation] = useState(dragDropInfo ? dragDropInfo.explanation : '');
  const [tip, setTip] = useState(dragDropInfo ? dragDropInfo.tip : '');
  const [priority, setPriority] = useState(dragDropInfo ? dragDropInfo.priority : '');
  const [difficulty, setDifficulty] = useState(dragDropInfo ? dragDropInfo.difficulty : '');
  const [pair, setPair] = useState(dragDropInfo ? dragDropInfo.variants.pair : [
    {
      pairOutId: 1,
      pairOutName: '',
      pairInId: 100,
      pairInName: ''
    }
  ]);

  const handleSubmit = (ev) => {
    ev.preventDefault();
    const result = {
      course_drag_and_drop: {
        kind,
        variants: { pair },
        question,
        explanation,
        tip,
        difficulty,
        priority
      }
    }

    if (question === '' ||
        difficulty === '' ||
        pair.length === 0 ||
        priority === ''
    ) {
      setError(true);
    } else {
      setError(false);
    }

    const checkPairEmpty = pair.filter(item => {
      return item.pairOutName === '' || item.pairInName === ''
    })

    if (checkPairEmpty.length > 0) {
      setErrorPairEmpty(true);
    } else {
      setErrorPairEmpty(false);
    }

    if (!(pair.length >= 2)) {
      setErrorPair(true);
    } else {
      setErrorPair(false);
    }

    if (question !== '' &&
        difficulty !== '' &&
        pair.length !== 0 &&
        priority !== '' &&
        pair.length >= 2 &&
        checkPairEmpty.length === 0
    ) {
      if (edit) {
        axios
          .patch(
            `/backend/admin/courses/${course.id}/topics/${topic.id}/lessons/${lesson.id}/drag_and_drops/${dragDropInfo.id}`,
            result,
            {
              headers: {
                'Content-Type': 'application/json',
                'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
              },
            }
          ).then(() => {
            location.href = `/backend/admin/courses/${course.id}/topics/${topic.id}/lessons/${lesson.id}#drag_and_drops`
          })
          .catch((e) => {
            if (e.response.data.priority[0] === 'уже существует') {
              setErrorPriority(true)
            }
          });
      } else {
        axios
          .post(
            `/backend/admin/courses/${course.id}/topics/${topic.id}/lessons/${lesson.id}/drag_and_drops`,
            result,
            {
              headers: {
                'Content-Type': 'application/json',
                'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
              },
            }
          ).then(() => {
            location.href = `/backend/admin/courses/${course.id}/topics/${topic.id}/lessons/${lesson.id}#drag_and_drops`
          })
          .catch((e) => {
            if (e.response.data.priority[0] === 'уже существует') {
              setErrorPriority(true)
            }
          });
      }
    }
  };

  const addPair = (index) => {
    setPair([...pair, {
      pairOutId: pair[index].pairOutId + 1,
      pairOutName: '',
      pairInId: pair[index].pairInId + 1,
      pairInName: ''
    }])
  }

  const deletePair = (todoIndex) => {
    const newArr = pair.filter((_, index) => index !== todoIndex);

    setPair(newArr);
  }

  const updateFieldChanged = (type, index) => e => {
    let newArr = [...pair];
    newArr[index][type] = e.target.value;
  
    setPair(newArr);
  }

  return (
    <form className="modal-form" onSubmit={handleSubmit} style={{ marginTop: '20px' }}>
      <div className="form-group string required">
        <label className="control-label string required" htmlFor="question">
          <abbr title="required">*</abbr>
            Вопрос
        </label>
        <Editor
          apiKey='kxcwvdfzs45kp41l80l8lqp32lhery31i1sqi88mjxynx1ur'
          onEditorChange={(e => setQuestion(e))}
          value={question}
          init={{
            height: 200,
            menubar: true,
            toolbar: 'undo redo | formatselect | ' +
            'bold italic backcolor | alignleft aligncenter ' +
            'alignright alignjustify | bullist numlist outdent indent | ' +
            'removeformat | help',
            content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
          }}
        />
      </div>
      <div className="form-group text">
        <label className="control-label text" htmlFor="tip">
          Подсказка
        </label>
        <textarea className="form-control text" defaultValue={tip} onChange={(e) => setTip(e.target.value)} id="tip" />
      </div>
      <div className="form-group text">
        <label className="control-label text" htmlFor="explanation">
          Решение
        </label>
        <Editor
          apiKey='kxcwvdfzs45kp41l80l8lqp32lhery31i1sqi88mjxynx1ur'
          onEditorChange={(e => setExplanation(e))}
          value={explanation}
          init={{
            height: 200,
            menubar: true,
            toolbar: 'undo redo | formatselect | ' +
            'bold italic backcolor | alignleft aligncenter ' +
            'alignright alignjustify | bullist numlist outdent indent | ' +
            'removeformat | help',
            content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
          }}
        />
      </div>
      <div className="form-group text">
        <label className="control-label text" htmlFor="priority">
          <abbr title="required">*</abbr>
          Приоритет
        </label>
        <input className="form-control text" type={'number'} defaultValue={priority} onChange={(e) => {setPriority(e.target.value);setErrorPriority(false);}} id="priority" />
      </div>
      <div className="form-group select">
        <label className="control-label select" htmlFor="difficulty">
          <abbr title="required">*</abbr>
          Сложность
        </label>
        <select className="form-control select" defaultValue={difficulty} onChange={(e) => setDifficulty(e.target.value)} id="difficulty">
          <option selected value=""></option>
          <option value="1">1</option>
          <option value="2">2</option>
          <option value="3">3</option>
        </select>
      </div>
      <div className="row">
        <div className="col">
          <label className="control-label integer" htmlFor="addWord">
            <abbr title="required">*</abbr>
            Добавить пару
          </label>
          {pair.map((item, index) => {
            return (
              <div className="form-inline" key={index} style={{ marginBottom: '13px' }}>
                <div className="mr-2">
                  <input
                    className="form-control"
                    type={'text'}
                    maxLength={20}
                    value={item.pairOutName}
                    onChange={updateFieldChanged('pairOutName', index)}
                  />
                </div>
                <div className="mr-2">
                  <input
                    className="form-control"
                    type={'text'}
                    maxLength={20}
                    value={item.pairInName}
                    onChange={updateFieldChanged('pairInName', index)}
                  />
                </div>
                {pair.length > 1 && <div className="mr-2">
                  <button name="button" type="button" className="btn btn-default btn-danger" onClick={() => deletePair(index)}>Удалить</button>
                </div>}
                {(pair.length === index + 1 && pair.length < 5) && <div className="mr-2">
                  <button name="button" type="button" className="btn btn-default btn-outline-primary" onClick={() => addPair(index)}>Добавить</button>
                </div>}
              </div>
            )
          })}
        </div>
      </div>

      {isError && <div className="error">Заполните все обязательные поля</div>}
      {isErrorPair && <div className="error">Количество пар не менее 2</div>}
      {isErrorPairEmpty && <div className="error">Пара не может быть пустой</div>}
      {isErrorPriority && <div className="error">Приоритет с таким значением уже существует</div>}
      <button type="submit" className="btn btn-default mtl-2 btn btn-outline-success">
        Отправить
      </button>
    </form>
  );
}

export default React.memo(DragAndDropWordMatching);


// WEBPACK FOOTER //
// ./app/frontend/components/DragAndDropWordMatching.js